import { Helmet } from "react-helmet-async";

interface MetaTagsProps {
  title: string;
  description: string;
  image: string;
  url: string;
}

const MetaTags: React.FC<MetaTagsProps> = ({ title, description, image, url }) => {
  return (
    <Helmet>
      {/* 기본 메타 태그 */}
      <title>{title}</title>
      <meta name="description" content={description} />

      {/* OpenGraph 태그 */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />

      {/* 카카오톡 전용 */}
      <meta property="kakao:title" content={title} />
      <meta property="kakao:description" content={description} />
      <meta property="kakao:image" content={image} />
    </Helmet>
  );
};

export default MetaTags;